<template>
  <div>
    <b-row>
      <b-col md="12" class="table-responsive">
        <div
          class="text-center text-danger my-2"
          v-if="
            !Array.isArray(getReferred.data) || getReferred.data.length === 0 ? true : false
          "
        >
          <span class="h2 text-danger"> {{ $t("not-referrals") }}</span>
        </div>
        <div v-else>
          <b-table
            class="align-items-center table-flush tablesorter table-text"
            hover
            :items="getReferred.data ? getReferred.data : []"
            :fields="columns"
            :per-page="getReferred.per_page"
            :current-page="getReferred.current_page"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <span class="h2 text-danger">{{ $t("fail") }}</span>
              </div>
            </template>
            <template v-slot:cell(name)="data">
              {{ data.item.referred.name }}
              {{ data.item.referred.lastname }}
            </template>
            <template v-slot:cell(date)="data">
              {{ data.item.created_at }}
            </template>
          </b-table>
          <b-pagination
            class="mt-3"
            v-model="getReferred.current_page"
            :total-rows="getReferred.total"
            :per-page="getReferred.per_page"
            :page-count="getReferred.per_page"
            @input="changePage"
            first-number
            pills
            size="sm"
            align="center"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "products-table",
  props: {
    type: {
      type: String,
    },
    data: {
      type: Object,
    },
    title: String,
  },
  async mounted() {
    this.debouncedGetAnswer = _.debounce(this.syncData, 500);
    await this.syncData()
  },
  data() {
    return {
     filter: {
      page: 1,
      per_page: 5,
      search: null
     }
    };
  },
  methods: {
    ...mapActions({
      listReferen: "myReferred",
    }),
    async syncData(){
       await this.listReferen(this.filter);
    },
    async changePage(value) {
     this.filter.page = value
     this.debouncedGetAnswer()
    },
  },
  computed: {
    ...mapGetters({
      getReferred: "getReferred",
    }),
    columns() {
      return [
        { label: this.$t("name"), key: "name", class: "text-center" },
        { label: this.$t("date"), key: "date", class: "text-center" },
      ];
    },
  },
};
</script>
<style scoped>
.dropdown-menu .dropdown-menu-right {
  position: relative !important;
}
</style>
